export default "__VITE_ASSET__BDLtfaUA__"